import { useArtSpecs } from "./Context";

export function Dots() {
  const { bp } = useArtSpecs();
  const size =
    bp < 672
      ? [100 / 40 + "%", 100 / 30 + "%", 100 / 80 + "%"]
      : bp < 1056
      ? // ? [100 / 84 + "%", 100 / 42 + "%", 100 / 168 + "%"]
        [100 / 56 + "%", 100 / 28 + "%", 100 / 112 + "%"]
      : ["16px", "16px", "8px"];

  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        margin: size[2],
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='1' fill='%23E0E0E0'/%3E%3C/svg%3E%0A")`,
        backgroundSize: `${size[0]} ${size[1]}`,
      }}
    />
  );
}
